import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { Button } from './Button';
export function Guarantee() {
  return <section className="py-24 md:py-32 px-6 bg-gray-900 text-white relative overflow-hidden" data-id="element-52">
      {/* Premium background accents */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-53">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-accent rounded-full mix-blend-screen filter blur-[100px] opacity-20" data-id="element-54" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-primary rounded-full mix-blend-screen filter blur-[100px] opacity-20" data-id="element-55" />
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gray-800/50 backdrop-blur-xl p-12 md:p-20 rounded-[3rem] shadow-2xl border border-gray-700/50 relative" data-id="element-57">
          <div className="absolute -top-12 left-1/2 -translate-x-1/2 w-24 h-24 bg-gradient-to-br from-accent-light to-accent rounded-full flex items-center justify-center shadow-xl shadow-accent/20 border-4 border-gray-900" data-id="element-58">
            <ShieldCheck className="w-12 h-12 text-gray-900" data-id="element-59" />
          </div>

          <h2 className="text-4xl md:text-6xl font-serif font-black text-white mt-8 mb-8" data-id="element-60">
            GARANTÍA DE 7 DÍAS
          </h2>

          <div className="space-y-6 text-xl md:text-2xl text-gray-300 leading-relaxed max-w-2xl mx-auto font-medium" data-id="element-61">
            <p className="text-white" data-id="element-62">Probala durante 7 días.</p>
            <p data-id="element-63">
              Si no sentís que recuperaste el placer de comer, simplemente
              solicitás la devolución.
            </p>
            <p className="text-accent font-bold text-2xl md:text-3xl pt-4" data-id="element-64">
              Sin preguntas.
            </p>
          </div>

          <div className="mt-12" data-id="element-65">
            <Button data-id="element-66">QUIERO VOLVER A DISFRUTAR LA COMIDA</Button>
          </div>
        </motion.div>
      </div>
    </section>;
}